import React from 'react';
import { connect } from 'react-redux';
import './styles.scss';

const CalculateInstallationMethod = props => (
  <div>
    <img className="installation-method-img" src={props.src} alt=""/>
  </div>
);

const mapState = state => ({
  src: state.selectors.calculate[state.main.appType].installationMethodImageSrc
});

export default connect(mapState)(CalculateInstallationMethod);



// WEBPACK FOOTER //
// ./src/views/Calculate/components/CalculateInstallationMethod/index.js